import React from 'react'
import { connect } from 'react-redux'
// import { Composite } from 'react-composite';
import styled from 'styled-components'

import { setEstimateItems, setEstimateChangeItem, setEstimateChecked, setEstimatePriceType } from '../../libs/action'
import { Api } from '../../libs/api'
import { getCookie, setCookie, setShareEstimateItems } from '../../libs/cookie'
import { numberFormat, estimate } from '../../libs/util'
import { scrollTo } from '../../libs/util'

// import NaverTalk from '../naverTalk'
import Item from './item'
// import Stdpc from './stdpc'
// import AddItem from './addItem'
// import Service from './service/service'
import Footer from './footer'
import { NoItems } from './error'
import { gaAddCartItemProcess } from '../../libs/googleTagmanager'
// import { commonAPI } from 'components/api/common'
import { serviceASItems } from "../../utils/serviceItem";
import StdpcChangeInfo from "./stdpcChangeInfo";
import AddItemInfo from "./addItemInfo";
import DefaultTwoButtonLayer from "../layer/defaultTwoButtonLayer";
import { itemAPI2 } from "../../libs/api2";
import {LAYER_ORANGE_POPUP, LAYER_POPUP} from "../../reducers/initial";
import ServiceComponent from "./service/serviceComponent";
// import DefaultOneButtonLayer from "../layer/defaultOneButtonLayer";


class Estimate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            /**
             * estimateItems : 견적 상품 목록
             */
            estimateItems: [],

            /**
             * estimateItemCounts : 견적 상품 개수
             * { "11460450": "3","11460451": "1" }
             */
            estimateItemCounts: {},
            mediumGuide: [],
            priceType: 'cash',
            /**
             * 견적리스트에서 카운터로 상품의 수량을 변경하는 경우
             * 변경된 상품번호가 배열에 저장된다.
             * 주의) 하단 상품리스트에서 견적담기를 누를 경우에는 배열에 저장되지 않는다.
             */
            changeItem: [],
            changeMode: null,
            checkedList: {},
            checkedAll: true,
            alertReset: { display: 'none' },
            stdpcItem: null,
            estLoading: false,
            itemListLoading : false,
            isCartItemHave: false,
            userId:null,
            mallId:null,
        }
        this.onEstimateResetClose = this.onEstimateResetClose.bind(this)
        this.estimateReset = this.estimateReset.bind(this)
    }


    componentDidMount() {
        if(this.props.estimateIdx){
            setShareEstimateItems(this.props.estimateIdx).then(() => {
                // const estimateItems = getCookie('item_est')
                // if (estimateItems) {
                //     this.props.setEstimateItems({ estimateItems })
                // } else{
                //     this.setState({itemListLoading : true})
                // }
                // this.totalPrice = 0
                // setCookie('estimateCommunity', '', 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
                //
                // /**
                //  * 미니샵이 카드 전문몰인 경우
                //  * priceType을 card로 변경한다.
                //  */
                //
                // if(this.props.miniShopInfo?.f_type === 1) {
                //     this.setState({ priceType: 'card' })
                // }
            })
        }else{
            const estimateItems = getCookie('item_est')
            if (estimateItems) {
                this.props.setEstimateItems({ estimateItems })
            } else{
                this.setState({itemListLoading : true})
            }
            this.totalPrice = 0
            setCookie('estimateCommunity', '', 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)

            /**
             * 미니샵이 카드 전문몰인 경우
             * priceType을 card로 변경한다.
             */

            if(this.props.miniShopInfo?.f_type === 1) {
                this.setState({ priceType: 'card' })
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.estimateItems !== this.props.estimateItems) {
            this.setEstimateItems(this.props.estimateItems)
        }

        if (prevProps.miniShopInfo !== this.props.miniShopInfo) {
            let priceType = 'cash'
            if (this.props.miniShopInfo?.f_type === 1) {
                priceType = 'card'
            }
            this.setState({ priceType })
            //console.log('estimate.js > parameter sNO 1')

            // 2021-12-15 miniShopInfo 가 null 인 경우
            // miniShopInfo 데이타 처리 ajax 완료전 실행될때가 있으며, null 이면 기본값 적용 예외처리
            let miniShop = this.props?.miniShopInfo
            let miniShopShopNO = miniShop?.shopNO || 1
            let miniShopType = miniShop?.f_type || 0



            this.setEstimateItems(this.props.estimateItems, miniShopType, miniShopShopNO)
        }
    }

    /**
     * 일반 전문몰 <-> 카드 전문몰 변경 함수
     * @param priceType
     */

    movePriceType(priceType) {
        if (priceType !== this.state.priceType) {
            this.setState({ priceType: priceType })
            this.setEstimateItems(this.props.estimateItems, priceType)
            this.props.setEstimatePriceType(priceType)

            // 2022-08-02 현금가(전체 최저가), 카드가(카드 최저가) 노출되게 수정 route.type
            let btn_type
            if(priceType === 'card') {
                btn_type = document.getElementById('devBtnTypeCard')
            } else {
                btn_type = document.getElementById('devBtnTypeCash')
            }
            if (btn_type !== undefined && btn_type !== '' && btn_type !== null) {
                btn_type.click()
            }
        }
    }

    setEstimateItems(estimateItems, priceType, shopNO) {
        let itemList = []
        let itemCounts = {}
        // 2022-08-01 '일반전문몰', '카드전문몰' 선택 상태값 유지, 없는 경우 '일반전문몰' 상태 적용
        let default_type = this.state.priceType
        if (default_type === undefined || default_type === '' || default_type === null) {
            default_type = 'cash'
        }

        let type = priceType || default_type
        let stdpcItem = null
        let changeItem = []
        let changeMode = null
        let mallID = this.props.miniShopInfo?.idx_b_manager
        if (shopNO) mallID = shopNO
        itemList = estimateItems.estimateItems ? estimateItems.estimateItems.split(',') : []

        itemList.map(v => {
            itemCounts[v] = getCookie('cnt_' + v)
            if (itemCounts[v] === null) {
                setCookie('cnt_' + v, 1, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
                itemCounts[v] = 1
                // console.log(itemCounts[v])
            }
            return true
        })
        if (estimateItems.type === 'add') {
            if (estimateItems.option === 'service') {
                changeItem = typeof estimateItems.itemId === 'object' ? estimateItems.itemId : [estimateItems.itemId]
                changeMode = estimateItems.option
            } else {
                stdpcItem = estimateItems.itemId
            }
        }
        if (itemList.length > 0) {
            this.setState({
                estLoading: true
            })
            Api.getEstimateList(itemList.join(','), type, mallID, stdpcItem).then(response => {
                if (response.data.code === 200) {
                    const items = response.data.data.itemList
                    if (items) {
                        let checkedList = {}
                        items.map(v => {
                            checkedList[v.itemID] = true
                            // console.log(v)
                            return true
                        })
                        this.setState({
                            estimateItems: items,
                            estimateItemCounts: itemCounts,
                            changeItem: changeItem,
                            firstLoading: false,
                            checkedList,
                            stdpcItem: stdpcItem,
                            changeMode,
                        })
                        this.props.setEstimateChecked(checkedList)
                    }
                    this.setState({itemListLoading : true})
                    this.setState({
                        estLoading: false
                    })
                    this.props.setIsEstimateLoading(false)
                }
            })
        } else {
            this.setState({ estimateItems: [], estimateItemCounts: [] })
            this.props.setIsEstimateLoading(false)
        }

    }

    setMediunguide(cate_id) {
        Api.getMediumGuide(cate_id).then(response => {
            if (response.data.code === 200) {
                const mediumGuide = response.data.data.medium_list
                if (mediumGuide) {
                    this.setState({ mediumGuide: mediumGuide })
                }
            }
        })
    }

    onChangeCount(itemId, type) {
        let estimateItems = this.props.estimateItems

        estimateItems = estimateItems.estimateItems ? estimateItems.estimateItems.split(',') : []
        let itemCounts = {}
        let itemIds = [itemId]

        estimateItems.map(v => {
            itemCounts[v] = getCookie('cnt_' + v)

            if (v.toString() === '1099785' && (
                // itemId.toString() === '76709' || itemId.toString() === '1154496'
                serviceASItems.includes(itemId.toString()))){

                // 2022-08-22 조립 + 1년 전국 출장 A/S 서비스 (1대분) 수량을 직접 수정(input box) 할 경우
                // 정품 부품박스 동봉 서비스 의 수량이 변경안되는 현상 수정
                if (type === undefined) {
                    itemCounts[v] = getCookie('cnt_' + itemId.toString())
                }

                if (type === 0 || type === undefined) {
                } else if (type === 'u') itemCounts[v] = parseInt(itemCounts[v], 10) + 1
                else itemCounts[v] = parseInt(itemCounts[v], 10) - 1

                if (itemCounts[v] < 1) itemCounts[v] = 1
                estimate.reEstimateItem(v, itemCounts[v])
                itemIds = [1099785, itemId]
            }
            return true
        })
        this.setState({ estimateItemCounts: itemCounts, changeItem: itemIds, changeMode: null })
    }

    onMovePage() {
        let estimateItems = this.props.estimateItems.estimateItems
        Object.keys(this.state.checkedList).map(item_id => {
            if (this.state.checkedList[item_id] === false) {
                estimateItems = estimate.delEsitmateItem(estimateItems, item_id)
            }
            return true
        })
        window.location.href = `${process.env.REACT_APP_PC_URL}/compare/${this.state.priceType}`
    }

    onCloseLayer(){
        this.setState({isCartItemHave: false})
    }
    onRemoveBasket(){
        Api.removeBasketByMall(this.state.userId, this.state.mallId).then(rst => {
            if (rst.data.desc === 'success') {
                this.onAddBasket()
            }
        })
    }
    /**
     * 장바구니에 담는 함수 분리
     * */
    onAddBasket(){
        let estimateItems = this.props.estimateItems
        estimateItems = estimateItems.estimateItems ? estimateItems.estimateItems.split(',') : []
        let addItemList = []
        estimateItems.map(v => {
            let count = getCookie('cnt_' + v)
            addItemList.push({ itemID: v, count })
            return true
        })

        Api.addBasket(this.state.mallId, this.state.userId, addItemList).then(rst => {
            if (rst.data.desc === 'success') {
                gaAddCartItemProcess(this.state.estimateItems, addItemList)
                window.location.href = process.env.REACT_APP_CART_URL
            }
        })
    }
    onMoveCart() {
        /**
         * 로그인 체크
         * 로그인 이후 다시 현재 미니샵 견적 페이지로 되돌아 올 수 있도록 returnUrl 파라미터를 추가
         *
         * cart 페이지로 이동시키려고 했으나, 견적상품을 회원에 담는 별도의 과정이 sso에서 필요하기 때문에
         * 로그인이 완료되면 다시 현재 미니샵 견적 페이지로 되돌아 오도록 처리
         */
        if (!this.props.userInfo) {
            let miniShopPath = window.location.pathname
            const returnUrl = `minishop.pping.${process.env.REACT_APP_TLD}${miniShopPath}`

            /**
             * returnUrl 파라미터 보안을 위한 인코딩
             * sso에 디코딩이 구현되어 있음
             * @type {string}
             */
            const encodingPath = encodeURIComponent(returnUrl)

            window.location.href = `${process.env.REACT_APP_SSO_URL}/?returnUrl=${encodingPath}`
            return false
        }

        const userId = this.props.userInfo.user_idx;
        const mallId = this.props.miniShopInfo.shopNO
        this.setState({userId : userId})
        this.setState({mallId : mallId})

        Api.getBasketCountByMall(userId, mallId).then(rst => {
            if (rst.data.desc === 'success') {
                if(rst.data.data.itemCount>0){
                    this.setState({isCartItemHave: true})
                }else{
                    this.onAddBasket()
                }
            }else{
                alert(rst.data.message)
            }
        })
    }

    onEstimateTalkMove() {
        // console.log('estimate.js > onEstimateTalkMove sNO 1')
        let shopNO = this.props.miniShopInfo.shopNO
        let estimateItems = []

        // let estimateItems = this.props.estimateItems.estimateItems

        Object.keys(this.state.checkedList).map(item_id => {
            if (this.state.checkedList[item_id] === true) {
                estimateItems.push(item_id + '|' + this.state.estimateItemCounts[item_id])
            }
            return true
        })

        let params = {
            itemIds: estimateItems.join(','),
            user_idx: this.props.userInfo.user_idx,
            b_manager: shopNO,
        }

        if (this.props.estimateMode === 'est_write') {
            Api.addEstimate(params).then(rst => {
                if (rst.data.code === 200) {
                    const idx_est = rst.data.result.idx_est
                    // alert('견적서 번호 : ' +idx_est)
                    setCookie('estimateCommunity', idx_est, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
                    setTimeout(window.close(), 500)
                }
            })
        } else {
            window.estimateCounselReact(this.props.estimateMode, shopNO, this.totalPrice)
        }
    }

    onMoveEstimate() {
        scrollTo('#layout_list_group')
    }

    onChecked(checked, itemId) {
        let checkedList = this.state.checkedList
        checkedList[itemId] = checked
        let allTrue = true
        for (let i in checkedList) {
            if (checkedList[i] === false) allTrue = false
        }
        this.setState({ checkedList, checkedAll: allTrue })
        this.props.setEstimateChecked(checkedList)
    }

    onCheckedAll(e) {
        let checkedList = this.state.checkedList
        for (let i in checkedList) {
            checkedList[i] = e.target.checked
        }
        this.setState({ checkedList, checkedAll: e.target.checked })
        this.props.setEstimateChecked(checkedList)
    }

    onEstimateReset() {
        this.setState({ alertReset: { display: '' } })
    }

    onEstimateResetClose() {
        this.setState({ alertReset: { display: 'none' } })
    }

    estimateReset() {
        estimate.delEstimateAllItems()
        this.props.setEstimateItems({ estimateItems: '' })
        this.setState({ alertReset: { display: 'none' } })
    }

    onClickEstimateSelectButton(replyId) {
        itemAPI2.setItemEstimate(this.props.miniShopInfo?.idx_b_manager).then((rst) => {
            if (rst?.data?.code === 400) {
                setCookie('auth_token', '', new Date(0), '/', `.pping.${process.env.REACT_APP_TLD}`)
                window.location.href = process.env.REACT_APP_SSO_URL
            } else if (rst.data.result) {
                const idx_est = rst.data.id ? rst.data.id : ''
                window.opener.postMessage({ idx_estimate: idx_est, ...(replyId ? { reply_id: replyId } : {}) }, `${process.env.REACT_APP_TALK_URL}`)
                window.close()
            }
        })
    }

    onClickConsultingButton()  {
        itemAPI2.setItemEstimate(this.props.miniShopInfo?.idx_b_manager).then((rst) => {
            if (rst?.data?.code === 400) {
                setCookie('auth_token', '', new Date(0), '/', `.pping.${process.env.REACT_APP_TLD}`)
                window.location.href = process.env.REACT_APP_SSO_URL
            } else if (rst.data.result) {
                const idx_est = rst.data.id ? rst.data.id : ''
                window.open(`${process.env.REACT_APP_TALK_URL}/bbs/17/register?idx_estimate=${idx_est}`, '_blank')
            }
        })
    }

    onClickEstimateBidding() {
        // this.props.displayLayerPopup('orange')
        // this.props.displayLayerOrangePopup({
        //     title: '<span><b>클로즈 베타(Closed Beta)</b><br/>서비스 중</span>',
        //     notice: '<span><b>테스트 완료되면 오픈 베타(Open Beta) 전환 예정</b><br/>(PC견적 관련 질문은 톡톡문의를 이용 바랍니다.)</span>'
        // })
        itemAPI2.setItemEstimate().then((rst) => {
            if (rst?.data?.code === 400) {
                setCookie('auth_token', '', new Date(0), '/', `.pping.${process.env.REACT_APP_TLD}`)
                window.location.href = process.env.REACT_APP_SSO_URL
            } else if (rst.data.result) {
                const idx_est = rst.data.id ? rst.data.id : ''
                window.open(`${process.env.REACT_APP_TALK_URL}/bbs/18/register?idx_estimate=${idx_est}`, '_blank')
            }
        })
    }

    render() {
        let miniShop = this.props?.miniShopInfo
        const params = new URLSearchParams(window.location.search)
        const consulting = params.get('consulting')
        const replyId = params.get('reply_id')

        // 2021-12-15 miniShopInfo 가 null 인 경우
        // miniShopInfo 데이타 처리 ajax 완료전 실행될때가 있으며, null 이면 기본값 적용 예외처리
        // let miniShopShopNO = miniShop?.shopNO || 1
        let miniShopType = miniShop?.f_type || 0
        // if (minishop.f_type)
        this.totalPrice = 0
        /**
         * 240610
         * user_idx사용하는 곳이 없어 주석처리함
         * */
        // let user_idx = ''
        // if (this.props.userInfo) user_idx = this.props.userInfo.user_idx

        return (
            <>
                {this.state.isCartItemHave && (
                    <DefaultTwoButtonLayer
                        title={<span style={{fontSize:'20px',lineHeight:'1.4',color:'#418ded'}}>해당 미니샵의 장바구니에<br/>상품이 존재합니다.<br/><strong>기존 장바구니를 삭제하시겠습니까?</strong></span>}
                        onClickLeft={()=>this.onAddBasket()}
                        leftButtonText="그대로 추가"
                        onClickRight={() => this.onRemoveBasket()}
                        rightButtonText="삭제 후 추가"
                        onClickClose={()=>this.onCloseLayer()}
                    />
                )}
                <fieldset className="estiList">
                    {this.state.estLoading && <Loading cdnimg={process.env.REACT_APP_CDN_IMG} />}
                    <legend>
                        <span>견적 상품</span>
                    </legend>
                    <div className="box-board">

                        <table className="board thead-top_noline">
                            <caption>
                                <span>견적 상품 </span>
                            </caption>
                            <colgroup>
                                <col style={{ width: '40px' }} />
                                <col style={{ width: '120px' }} />
                                <col />
                                <col style={{ width: '100px' }} />
                                <col style={{ width: '77px' }} />
                                <col style={{ width: '100px' }} />
                                <col style={{ width: '50px' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <span className="icheck">
                                            <input
                                                type="checkbox"
                                                id="id-allcheck3"
                                                name="name-allcheck3"
                                                checked={this.state.checkedAll}
                                                onClick={e => this.onCheckedAll(e)}
                                                onChange={() => {}}
                                            />
                                            <label htmlFor="id-allcheck3">
                                                <span className="ir">전체선택</span>
                                            </label>
                                        </span>
                                    </th>
                                    <th scope="col">분류</th>
                                    <th scope="col">상품명</th>
                                    <th scope="col">판매가격</th>
                                    <th scope="col">수량</th>
                                    <th colSpan="2" scope="col">견적금액</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.estimateItems.map((v, i) => {
                                    if(typeof v.price === 'number'){
                                        this.totalPrice += parseInt(v.price, 10) * parseInt(this.state.estimateItemCounts[v.itemID], 10)
                                    }
                                    return (
                                        <React.Fragment key={i}>
                                            <Item
                                                onChangeCount={(itemId, type) => this.onChangeCount(itemId, type)}
                                                itemData={v}
                                                count={this.state.estimateItemCounts[v.itemID]}
                                                checked={this.state.checkedList[v.itemID]}
                                                onChecked={(checked, itemId) => this.onChecked(checked, itemId)}
                                                windowsItemList={this.props.serviceOsList}
                                            />

                                            {/*견적리스트에서 카운터로 상품의 수량을 변경한 경우*/}
                                            {/*AddItem 컴포넌트를 렌더링한다.*/}
                                            {/*아니면 Stdpc 컴포넌트를 렌더링한다.*/}

                                            {this.state.changeItem.indexOf(v.itemID) !== -1 ? (
                                                <AddItemInfo mode={this.state.changeMode} count={this.state.estimateItemCounts[v.itemID]} />
                                            ) : this.state.stdpcItem === v.itemID ? (

                                                <StdpcChangeInfo
                                                    stdpcData={v.stdpcInfo}
                                                    count={this.state.estimateItemCounts[v.itemID]}
                                                    mediumGuide={this.state.mediumGuide}
                                                    changeItem={this.state.changeItem}
                                                />
                                            ) : null}
                                        </React.Fragment>
                                    )
                                })}
                                {this.state.estimateItems.length === 0 && (
                                    <React.Fragment>
                                        <NoItems onMoveEstimate={() => this.onMoveEstimate()} itemListLoading={this.state.itemListLoading}/>
                                        {/* <NoLogin /> */}
                                    </React.Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {this.state.estimateItems.length === 0 || (
                        <React.Fragment>
                            {/* <!-- 추가 서비스 --> */}
                            {/* OS 구매확인을 위한 props 생성 */}
                            {/*<Service*/}
                            {/*    cateData={this.state.estimateItems}*/}
                            {/*    windowsItemList={this.props.serviceOsList}*/}
                            {/*/>*/}
                            {/*서비스 개선*/}
                            <ServiceComponent/>
                            {/* <!-- // 추가 서비스 --> */}

                            {/* <!-- 총견적 --> */}
                            <div className="cart-body_compare_sum">
                                <h3 className="tit-h3">총 견적금액</h3>

                                <div className="cart-body_compare_sum_price">
                                    {miniShopType === 1 || (
                                        <span className="iradio">
                                            <input
                                                type="radio"
                                                id="id-m1"
                                                name="name-m"
                                                checked={this.state.priceType === 'cash'}
                                                onChange={() => this.movePriceType('cash')}
                                            />
                                            <label htmlFor="id-m1">일반전문몰</label>
                                        </span>
                                    )}
                                    {miniShopType === 2 || (
                                        <span className="iradio">
                                            <input
                                                type="radio"
                                                id="id-m2"
                                                name="name-m"
                                                checked={this.state.priceType === 'card'}
                                                onChange={() => this.movePriceType('card')}
                                            />
                                            <label htmlFor="id-m2">카드전문몰</label>
                                        </span>
                                    )}

                                    <strong className="price">
                                        <span>{numberFormat(this.totalPrice)}</span>원
                                    </strong>
                                </div>
                            </div>
                            {/* <!-- // 총견적 --> */}

                            <ButtonGroup className="button-group ctr">
                                <EstimateRewriteButton
                                    className="btn-continue-shopping"
                                    style={window.isMiniShop || consulting === 'true' ? { width: '310px' } : { width: '230px' }}
                                    onClick={() => this.onEstimateReset()}>
                                    견적 다시 작성하기
                                </EstimateRewriteButton>

                                {consulting !== 'true' && (
                                    <>
                                        <EstimateConsultingButton type='button' style={window.isMiniShop ? { width: '310px' } : {}} onClick={() => this.onClickConsultingButton()}>
                                            견적 상담하기
                                            <EstimateConsultingToolTip>
                                                <ToolTipText>구매 전 견적의 호환성이 궁금하시면!</ToolTipText>
                                            </EstimateConsultingToolTip>
                                        </EstimateConsultingButton>
                                    </>
                                )}

                                {/*app.js에서 미니샵으로 설정하더라도*/}
                                {/*window.inMiniShop이 false로 나오는 문제가 있어서*/}
                                {/*minishop 장바구니 담기 버튼을 수정시에만*/}
                                {/*장바구니가 노출 되도록 설정*/}

                                {/*<button className="btn-buy-submit" onClick={() => this.onMoveCart()}>*/}
                                {/*    장바구니 담기*/}
                                {/*</button>*/}

                                {consulting === 'true' ? (
                                    <>
                                        <EstimateSelectButton type='button' onClick={() => this.onClickEstimateSelectButton(replyId)}>견적서 선택하기</EstimateSelectButton>
                                        <EstimateSelectToolTip>
                                            <ToolTipText>PC견적 작성 후 버튼 클릭시 톡톡 서비스에 자동 적용됩니다.</ToolTipText>
                                        </EstimateSelectToolTip>
                                    </>
                                ) : (
                                    window.isMiniShop ? (
                                        <CartAddButton className="btn-buy-submit" onClick={() => this.onMoveCart()}>
                                            장바구니 담기
                                        </CartAddButton>
                                    ) : (
                                        <EstimatePurchaseButton className="btn-buy-submit" onClick={() => this.onMovePage()}>
                                            견적 바로 구매하기
                                            <EstimatePurchaseToolTip>
                                                <ToolTipText>즉시 구매를 원하시면!</ToolTipText>
                                            </EstimatePurchaseToolTip>
                                        </EstimatePurchaseButton>
                                    )
                                )}

                                {!window.isMiniShop && consulting !== 'true' ? (
                                    <>
                                        <EstimateBidButton type='button' onClick={() => this.onClickEstimateBidding()}>
                                            견적 입찰하기
                                            <EstimateBidToolTip>
                                                <ToolTipText>보다 저렴한 구매를 원하시면!</ToolTipText>
                                            </EstimateBidToolTip>
                                        </EstimateBidButton>
                                    </>
                                ) : null}
                            </ButtonGroup>

                            { this.state.alertReset.display === '' && <DefaultTwoButtonLayer
                                title='기존에 담긴 상품은 초기화 됩니다.'
                                onClickLeft={this.onEstimateResetClose}
                                leftButtonText="취소"
                                onClickRight={this.estimateReset}
                                rightButtonText="확인"
                            />}

                            {/*<div className="layer-pop TopBanLay" style={this.state.alertReset}>*/}
                            {/*    <div className="layer-pop_comm_confirm">*/}
                            {/*        <strong className="pop_comm_confirm_msg">기존에 담긴 상품은 초기화 됩니다.</strong>*/}
                            {/*        <div className="button-group ctr">*/}
                            {/*            <button*/}
                            {/*                type="button"*/}
                            {/*                className="btn_border"*/}
                            {/*                onClick={() => this.onEstimateResetClose()}*/}
                            {/*            >*/}
                            {/*                취소*/}
                            {/*            </button>*/}
                            {/*            <button type="button" className="btn_flat" onClick={() => this.estimateReset()}>*/}
                            {/*                확인*/}
                            {/*            </button>*/}
                            {/*        </div>*/}
                            {/*        <button*/}
                            {/*            type="button"*/}
                            {/*            className="icon-close btn-layer-pop_clse"*/}
                            {/*            onClick={() => this.onEstimateResetClose()}*/}
                            {/*        >*/}
                            {/*            <span className="ir">닫기</span>*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*</div>*/}


                            <Footer />
                        </React.Fragment>
                    )}
                </fieldset>
            </>
        )
    }
}

const Loading = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: ${props => `rgba(255,255,255,0.6) url(${props.cdnimg}/img_static/img_pres/_v5/happy_loading_5.gif) no-repeat center`};
    background-size: 60px 69px;
`

const ButtonGroup = styled.div`
    margin-top:62px !important;
    && {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 10px;
    }
`

const EstimateSelectButton = styled.button`
    && {
        font-size: 24px;
        font-weight: bold;
        width: 630px;
        height: 70px;
        border: 0;
        color: #fff;
        background-color: #418ded;
        text-align: center;
        line-height: 70px;
        vertical-align: middle;
        letter-spacing: 0;
        cursor: pointer;
        box-sizing: border-box;
        &:hover {
            background-color: #2D7EE4;
        }
    }
`

const ToolTipBefore = styled.div`
    width: auto;
    height: 30px;
    padding: 0 12px;
    background-color: rgb(72, 72, 72);
    border: 1px solid rgb(51, 51, 51);
    color: rgb(255, 255, 255);
    font-size: 11px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    box-sizing: border-box;
    position: absolute;
    top: -42px;
    right: 0;
    &:before {
        position: absolute;
        content: "";
        width: 15px;
        height: 15px;
        border-bottom: 1px solid rgb(51, 51, 51);
        border-right: 1px solid rgb(51, 51, 51);
        bottom: -8px;
        left: 10px;
        transform: rotate(45deg);
        background: rgb(72, 72, 72);
        z-index: 9;
    }
`
const ToolTip = styled.div`
    width: auto;
    height: 30px;
    //padding: 0 12px;
    background-color: rgb(72, 72, 72);
    //border: 1px solid rgb(51, 51, 51);
    color: rgb(255, 255, 255);
    font-size: 11px !important;
    font-weight: 400 !important;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    box-sizing: border-box;
    position: absolute;
    top: -42px;
    right: 0;
    &:before {
        position: absolute;
        content: "";
        width: 15px;
        height: 15px;
        border-bottom: 1px solid rgb(51, 51, 51);
        border-right: 1px solid rgb(51, 51, 51);
        bottom: -8px;
        left: 3px;
        transform: rotate(45deg);
        background: rgb(72, 72, 72);
        z-index: 9;
    }
`

const ToolTipText = styled.span`
    z-index: 10;
`

const EstimateConsultingToolTip = styled(ToolTip)`
    width:100%;
`

const EstimateSelectToolTip = styled(ToolTipBefore)`
    margin-right: 170px;
`

const EstimatePurchaseToolTip = styled(ToolTip)`
    width:100%;
`

const EstimateBidToolTip = styled(ToolTip)`
    width:100%;
`


const ActionButton = styled.button`
    && {
        font-size: 24px;
        font-weight: bold;
        width: 230px;
        height: 70px;
        border: 0;
        color: #fff;
        background-color: #418ded;
        text-align: center;
        line-height: 70px;
        vertical-align: middle;
        letter-spacing: 0;
        cursor: pointer;
        box-sizing: border-box;
        &:hover {
            background-color: #2D7EE4;
        }
        position: relative;
    }
`;

const EstimateBidButton = ActionButton;
const EstimateConsultingButton = ActionButton;

const EstimateRewriteButton = styled.button`
    && {
        margin-right: 0 !important;
        &:hover {
            background-color: #2D7EE4;
        }
    }
`

const EstimatePurchaseButton = styled.button`
    && {
        width: 230px !important;
        position:relative;
    }
`

const CartAddButton = styled.button`
    && {
        width: 310px !important;
    }
`

let stateData = state => {
    return {
        selectCategory: state.initial.selectCategory,
        estimateItems: state.estimateAdd.estimateItems,
        isLogin: state.user.isLogin,
        estimateChangeItem: state.estimateAdd.estimateChangeItem,
        estimateMode: state.estimateAdd.estimateMode,
        miniShopInfo: state.initial.minishopInfo,
        userInfo: state.user.userInfo,
        categoryData: state.category.categoryData,
        domain : state.initial.domain,
        serviceOsList : state.initial.serviceOsList
    }
}

let dispatchData = dispatch => {
    return {
        setEstimateItems: estimateItems => dispatch(setEstimateItems(estimateItems)),
        setEstimateChangeItem: estimateChangeItem => dispatch(setEstimateChangeItem(estimateChangeItem)),
        setEstimateChecked: estimateChecked => dispatch(setEstimateChecked(estimateChecked)),
        setEstimatePriceType: priceType => dispatch(setEstimatePriceType(priceType)),
        displayLayerPopup: data => dispatch({
            type: LAYER_POPUP,
            data,
        }),
        displayLayerOrangePopup: data => dispatch({
            type: LAYER_ORANGE_POPUP,
            data,
        })
    }
}

export default connect(
    stateData,
    dispatchData,
)(Estimate)
// export default Default;



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/estimate.js